import FormattedMessage from 'I18n/components/FormattedMessage';
import { FORM_FIELD_ERROR_TYPES } from 'FormsUI/constants/FormFieldErrorTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const FormFieldErrorMessage = ({
  formFieldError
}) => {
  switch (formFieldError.type) {
    case FORM_FIELD_ERROR_TYPES.NO_FIELD_NAME:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "form-control-validation-error",
        message: "editor.validation.noFieldName"
      });
    case FORM_FIELD_ERROR_TYPES.INVALID_FORM_FIELD:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "form-control-validation-error",
        message: "editor.validation.invalidFieldName"
      });
    case FORM_FIELD_ERROR_TYPES.UPDATE_ERROR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "form-control-validation-error",
        message: `editor.form.savingError.message.${formFieldError.key}`
      });
    default:
      return null;
  }
};
export default FormFieldErrorMessage;